<template>
	<a
		class="btn-tappable"
		href="javascript:void(0)"
	>
		<slot />
	</a>
</template>
